import { formatDate } from "@angular/common"
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { DialogService, DossierService, FormulaireService, FoyerService, StateService } from "../../../../../services"

@Component({
	selector: 'atyl-foyer-actions-dialog',
	templateUrl: './foyer-actions-dialog.component.html',
	styleUrls: ['./foyer-actions-dialog.component.scss']
})
export class FoyerActionsDialog extends BaseDialogComponent implements OnInit {

	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formulaireService: FormulaireService,
		public dialogRef: MatDialogRef<FoyerActionsDialog>,
		private foyerService: FoyerService,
		private snackbar: MatSnackBar,
		private stateService: StateService,
		private dossierService: DossierService,
		dialogService: DialogService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}
	FOYER_DATA_TYPE: string = "foyer";
	currentAction: string
	currentDataType: string
	currentFormulaire: any
	atylComponents: any = '';
	atylTemplate: any = '';
	listUnderForms: any[] = [];
	currentActiveService: any = null;
	loading: boolean = true;
	hasPrevButton: boolean = false;
	hasNextButton: boolean = false;
	indexForm: number = 0;
	isEditable: boolean = true;
	closeWhenValidate: boolean = true;
	currentActiveMethode: string
	dossier: any = null;
	@Output() submited = new EventEmitter<any>();

	ngOnInit() {

		if (this.data) {
			this.currentAction = this.data.action
			this.currentDataType = this.data.dataType
			this.dossier = this.data.dossier
		}

		this.formulaireService.v3_getByCode(this.data.code).subscribe((res: JSONRpcResponse) => {
			this.currentFormulaire = res.result
			this.listUnderForms = res.result.under_form
			if (res.result && res.result.fields.length > 0 && res.result.template) {
				res.result.parent = true
				this.listUnderForms.unshift(res.result)
				this.atylComponents = JSON.stringify(res.result.fields)
				this.atylTemplate = res.result.template
				this.changeDetectorRef.detectChanges()
			}
			this.handelActions()
		})

	}

	handelActions() {
		switch (this.currentDataType) {
			case 'foyer':
				this.handelFoyerActions()
				break
		}
	}

	handelFoyerActions() {
		switch (this.currentAction) {
			case 'create':
				this.createFoyer()
				break
			case 'add': {
				this.addToFoyer()
				break
			}
		}
	}

	/**
	 * Foyer Actions
	 * Available actions: [ CREATE, ADD ]
	 */
	createFoyer() {
		this.loading = false
		this.changeDetectorRef.detectChanges()
	}

	addToFoyer() {
		this.loading = false
		this.changeDetectorRef.detectChanges()
	}

	onLoaded(loaded: boolean) {
		if (loaded)
			this.changeDetectorRef.markForCheck()
	}

	getSubmittedEmitter() {
		return this.submited
	}
	onSubmit(event: any) {
		if (event.close) {
			this.closeWhenValidate = true
		}
		for (var i = 0; i < this.currentFormulaire.fields.length; i++) {
			var field = this.currentFormulaire.fields[i]
			if (event.hasOwnProperty(field.ID)) {
				var val = event[field.ID]

				if (field.field.type == 'date' && val != "") {
					var utcDate = formatDate(val, "yyyy-MM-ddTHH:mm:ss", "fr-FR")
					val = utcDate
				}

				field["value"] = val
				this.currentFormulaire.fields[i] = field
			}
		}
		if (this.closeWhenValidate) {
			this.dialogRef.close(this.currentFormulaire)
		} else {
			this.ngOnInit()
		}
		this.handelSubmit()
	}

	handelSubmit() {
		console.log(this.dossier)
		let form = {
			"ID": this.currentFormulaire.ID,
			"fields": this.filterFields(this.currentFormulaire.fields)
		}

		let options = {
		}

		if (this.dossier != undefined && this.dossier.tiers != undefined)
			options["tiers"] = this.dossier.tiers.ID

		if (this.currentDataType == this.FOYER_DATA_TYPE) {
			switch (this.currentAction) {
				case 'create':
					this.foyerService.new(form, options).subscribe((res: JSONRpcResponse) => {
						if (res.result.success) {
							let snackBarRef = this.snackbar.open('Foyer enregistré', 'Fermer', {
								duration: 2500
							})
							snackBarRef.afterDismissed().subscribe(res => {
								console.log(res)
							})
						} else {
							let snackBarRef = this.snackbar.open('Une erreur est survenue', '', {
								duration: 2500
							})
						}
					})
					break
				case 'add':
					this.foyerService.addTiersToFoyer(form, options).subscribe((res: JSONRpcResponse) => {
						if (res.result.success) {
							let snackBarRef = this.snackbar.open('Tiers Ajouté', '', {
								duration: 2500
							})
							this.dossierService.get(this.dossier.ID).subscribe((res: JSONRpcResponse) => {
								this.dossier = res.result
								this.stateService.updateDossier(this.dossier)
							})
						} else {
							let snackBarRef = this.snackbar.open('Une erreur est survenue', '', {
								duration: 2500
							})
						}
					})
					break

			}
		}
	}
	filterFields(fields: any) {
		let values = []
		fields.forEach((field: any) => {
			if (typeof field.value == 'object') {
				field.value.forEach((v: any) => {
					if (values.indexOf(v) === -1) {
						values.push(v)
					}
				})
				field.value = values
			}
		})
		return fields
	}

}
